import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  records: [],
  meta: {
    unreadCount: 0,
  },
  uiFlags: {
    isFetching: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
